import type { PdfSearchMatchRect } from "../hooks/usePdfSearchWithRects";

interface PdfSearchHighlightLayerProps {
  matches: PdfSearchMatchRect[];
  activeMatch: PdfSearchMatchRect | null;
  zoom: number;
}

export function PdfSearchHighlightLayer({
  matches,
  activeMatch,
  zoom,
}: PdfSearchHighlightLayerProps) {
  if (!matches.length) return null;

  return (
    <div className="absolute inset-0 pointer-events-none z-10">
      {matches.map((m, i) => {
        const isActive =
          activeMatch &&
          activeMatch.pageNumber === m.pageNumber &&
          activeMatch.startIndex === m.startIndex &&
          activeMatch.rect.x === m.rect.x &&
          activeMatch.rect.y === m.rect.y;

        return (
          <div
            key={i}
            className={`absolute rounded-sm ${
              isActive
                ? "bg-orange/50"
                : "bg-warning/40"
            }`}
            style={{
              left: m.rect.x * zoom,
              top: m.rect.y * zoom,
              width: m.rect.w * zoom,
              height: m.rect.h * zoom,
            }}
          />
        );
      })}
    </div>
  );
}
